import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '@project/server';

type TrpcClient = ReturnType<typeof createTRPCReact<AppRouter>>;

// Export the hooks library
export const trpc: TrpcClient = createTRPCReact<AppRouter>();
